var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareIgLionDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1080 1920"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Share_IG_Lion_Dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F9FA",
  d: "M0 0h1080v1920H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1080,
  height: 1920,
  fill: "#12192B",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE591",
  d: "M803 1832.43c-132.8-8.97-187.167 130.48-193 187.57h576v-947c-88.33 25.48-272.8 111.52-304 251.79-39 175.33 128.5 145.26 160 279.81 31.5 134.56-73 239.05-239 227.83",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.08,
  d: "M35.51 263.741c-46.674-34.899-75.295-75.514-40.162-122.5 35.132-46.985 97.087-50.95 143.76-16.051s99.071 97.081 63.938 144.067-120.863 29.382-167.536-5.516"
}), /*#__PURE__*/React.createElement("rect", {
  width: 949,
  height: 967,
  x: 110,
  y: 505,
  fill: "#1199FA",
  fillOpacity: 0.15,
  rx: 4
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Share_IG_Lion_Dark_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 788,
  height: 1401,
  x: 146,
  fill: "#002F61",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 788,
  height: 1401,
  x: 146,
  fill: "url(#Share_IG_Lion_Dark_svg__c)",
  fillOpacity: 0.3,
  rx: 4
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#323C52",
  strokeWidth: 2,
  d: "M340 1651h400"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1199FA",
  fillOpacity: 0.1,
  d: "M846.715 1833.46c-10.343 14.64-22.619 23.75-37.458 13.27-14.839-10.49-16.641-29.55-6.298-44.19 10.342-14.63 29.058-31.23 43.897-20.75 14.838 10.49 10.202 37.04-.141 51.67"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#Share_IG_Lion_Dark_svg__d)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M466.492 1787.16c-6.65 0-11.564-5.19-11.564-11.57 0-6.39 4.914-11.71 11.606-11.71 4.238 0 6.864 1.57 8.94 3.85l-3.177 3.42c-1.568-1.65-3.22-2.79-5.805-2.79-3.729 0-6.439 3.21-6.439 7.14 0 4.02 2.754 7.23 6.693 7.23 2.416 0 4.195-1.14 5.805-2.79l3.092 3.04c-2.202 2.45-4.787 4.18-9.151 4.18m18.879 0h-5.125v-23.24h5.125v5.46c1.398-3.34 3.982-5.63 7.922-5.46v5.41h-.297c-4.49 0-7.625 2.92-7.625 8.83zm34.755-23.28-11.327 29.54h-5.197l2.476-6.25-9.705-23.29h5.465l6.621 17.2 6.357-17.2zm15.122 4.44c-3.474 0-6.524 2.83-6.524 7.18 0 4.36 3.05 7.19 6.524 7.19 3.517 0 6.396-2.75 6.396-7.19 0-4.39-2.923-7.18-6.396-7.18m1.185 18.8c-3.684 0-6.015-1.86-7.584-3.93v10.23h-5.124v-29.54h5.124v4.18c1.654-2.32 3.985-4.18 7.584-4.18 5.296 0 10.423 4.18 10.423 11.62s-5.084 11.62-10.423 11.62m21.661-18.38v10.94c0 1.99 1.011 2.79 2.752 2.79h2.011v4.57h-3.506c-3.731-.02-6.382-1.67-6.382-6.55v-11.75h-2.846v-4.39h2.846v-6.13h5.125v6.13h4.763v4.39zm20.976-.38c-4.11 0-6.736 3.21-6.736 7.14 0 3.97 2.838 7.23 6.821 7.23 4.15 0 6.778-3.21 6.778-7.14 0-3.98-2.839-7.23-6.863-7.23m0 18.8c-6.821 0-11.863-5.19-11.863-11.57 0-6.43 5.083-11.71 11.948-11.71 6.862 0 11.904 5.2 11.904 11.62 0 6.38-5.085 11.66-11.989 11.66m21.372-4.68v2.57c0 .11-.054.21-.149.26l-2.236 1.29a.31.31 0 0 1-.297 0l-2.242-1.29a.3.3 0 0 1-.149-.26v-2.57a.3.3 0 0 1 .149-.26l2.242-1.29a.31.31 0 0 1 .297 0l2.236 1.29c.095.05.149.15.149.26m39.626-14.12c-4.11 0-6.736 3.21-6.736 7.14 0 3.97 2.838 7.23 6.821 7.23 4.15 0 6.776-3.21 6.776-7.14 0-3.98-2.837-7.23-6.861-7.23m0 18.8c-6.821 0-11.863-5.19-11.863-11.57 0-6.43 5.084-11.71 11.948-11.71 6.862 0 11.904 5.2 11.904 11.62 0 6.38-5.085 11.66-11.989 11.66m-24.019-.02c-6.65-.13-11.464-5.42-11.34-11.8.123-6.38 5.138-11.61 11.829-11.48 4.237.08 6.832 1.7 8.865 4.02l-3.243 3.36c-1.535-1.68-3.164-2.85-5.749-2.9-3.727-.07-6.501 3.09-6.577 7.01-.077 4.02 2.616 7.28 6.553 7.36 2.416.04 4.217-1.06 5.857-2.68l3.035 3.1c-2.249 2.41-4.866 4.09-9.23 4.01m66.477-23.26c4.873 0 7.837 3.09 7.837 8.54v14.74h-5.125v-13.18c0-3.55-1.653-5.45-4.533-5.45-2.795 0-4.788 1.94-4.788 5.54v13.09h-5.125v-13.22c0-3.47-1.696-5.41-4.535-5.41-2.837 0-4.787 2.11-4.787 5.58v13.05h-5.126v-23.28h5.126v3.85c1.441-1.99 3.391-3.85 6.821-3.85 3.22 0 5.465 1.57 6.651 3.93 1.824-2.36 4.195-3.93 7.584-3.93"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M388 1759.32v29.04l25.092 14.53 25.086-14.53v-29.04l-25.086-14.53zm2.209 27.77v-26.49l22.883-13.26 22.884 13.26v26.49l-22.884 13.25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M422.925 1757.33h-19.716l-2.285 10.08h24.377zm-16.218 23.95v-6.69l-5.84-3.73-6.609 4.93 9.009 15.71h3.598l4.256-3.98v-1.99z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M419.495 1768.93h-12.766l2.15 5.63-.655 6.31h4.866l4.912-.02-.612-6.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "m425.336 1770.82-5.773 3.77v6.69l-4.413 4.25v1.99l4.255 3.93h3.553l8.965-15.66z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFD348",
  opacity: 0.06
}, /*#__PURE__*/React.createElement("circle", {
  cx: 62.406,
  cy: 1439.32,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.406,
  cy: 1500.36,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.406,
  cy: 1561.41,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.406,
  cy: 1622.59,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.404,
  cy: 1683.68,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62.404,
  cy: 1745.32,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1439.32,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1500.36,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1561.41,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1622.59,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1683.68,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.359,
  cy: 1745.32,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1439.32,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1500.36,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1561.41,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1622.59,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1683.68,
  r: 15.318
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123.451,
  cy: 1745.32,
  r: 15.318
})), /*#__PURE__*/React.createElement("circle", {
  cx: 833.234,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 833.234,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 833.234,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 974.031,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 974.031,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 974.031,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 923.652,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 923.652,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 923.652,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1064.45,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1064.45,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1064.45,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 878.443,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 878.443,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 878.443,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1019.24,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1019.24,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1019.24,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 787.465,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 741.344,
  cy: 4.344,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 787.465,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 741.344,
  cy: 49.553,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 787.465,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 741.344,
  cy: 94.762,
  r: 11.344,
  fill: "#1199FA",
  fillOpacity: 0.1
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Share_IG_Lion_Dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1080v1920H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Share_IG_Lion_Dark_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M388 1743h304v61H388z"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Share_IG_Lion_Dark_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(64.468 -80.367 578.191)scale(1289.97 770.163)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "Share_IG_Lion_Dark_svg__b",
  width: 828,
  height: 1441,
  x: 126,
  y: -16,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1445_138221"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1445_138221",
  result: "shape"
})))));
export default SvgShareIgLionDark;